export const GA_MEASUREMENT_ID = 'G-6Z6SMF6LBP';

export const trackEvent = (name, params = {}) => {
  let consent = null;
  try {
    consent = window.localStorage.getItem('connecto_analytics_consent');
  } catch (error) {
    return;
  }

  if (consent === 'granted' && typeof window.gtag === 'function') {
    window.gtag('event', name, {
      ...params,
      send_to: GA_MEASUREMENT_ID,
    });
  }
};
